<template>
  <div class="box-detail">
    <div class="box-left">
      <div class="box-left-header-contact">
        <div @click="$router.push({ path: '/Coupons' })" class="goBack">
          <i class="el-icon-arrow-left"></i>
          <span>活动</span>
          <i class="el-icon-s-custom"></i>
        </div>
        <div class="profile-info">
          <el-image
            style="width: 72px; height: 72px;border-radius:50%;"
            src="https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg"
            fit="cover"
            v-if="false"
          ></el-image>
          <span v-if="false">{{ formData.name }}</span>
          <ul class="shortcuts" v-if="false">
            <li>
              <el-tooltip
                class="item"
                effect="dark"
                content="打个电话"
                placement="top"
                :open-delay="300"
              >
                <a :href="'tel:' + formData.phone">
                  <el-button icon="el-icon-phone f-bold" circle></el-button>
                </a>
              </el-tooltip>
              <span>呼叫</span>
            </li>
            <li>
              <el-tooltip
                class="item"
                effect="dark"
                content="发送邮件"
                placement="top"
                :open-delay="300"
              >
                <a :href="'mailto:' + formData.email">
                  <el-button icon="el-icon-message f-bold" circle></el-button>
                </a>
              </el-tooltip>
              <span>邮件</span>
            </li>
            <li>
              <el-tooltip
                class="item"
                effect="dark"
                content="创建笔记"
                placement="top"
                :open-delay="300"
              >
                <el-button
                  icon="el-icon-edit-outline f-bold"
                  circle
                  @click="
                    activeTab = 'notes';
                    openNote = true;
                  "
                ></el-button>
              </el-tooltip>
              <span>笔记</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="box-left-content">
        <el-form
          :model="formData"
          :rules="rules"
          ref="formData"
          label-width="160px"
          label-position="left"
          hide-required-asterisk:true
        >
          <el-form-item label="活动名称" prop="title">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>
          <!-- <el-form-item label="优惠券编号" prop="code">
            <el-input v-model="formData.code"></el-input>
          </el-form-item> -->

          <el-form-item label="优惠券适用范围类型" prop="scopeType">
            <el-select v-model="formData.scopeType" clearable @change="delete formData.scopeId">
              <el-option
                v-for="item in options.couponType"
                :key="item.value"
                :label="item.label"
                :value="+item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="$util.isShowField(formData, 'scopeType', 'scopeType', 1)"
            label="适用产品"
            :rules="{
              required: true,
              trigger: 'blur',
              message: '适用产品不能为空'
            }"
            prop="scopeId"
          >
            <el-select v-model="formData.scopeId">
              <el-option
                v-for="item in ProductsList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item
          label="优惠券适用类型"
          :rules="{ required: true, trigger: 'blur', message: '类型不能为空' }"
          prop="scopeType"
        >
          <el-select v-model="formData.scopeType">
            <el-option
              v-for="item in options.couponType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="适用产品"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '适用产品不能为空'
          }"
          prop="scopeId"
        >
          <el-select v-model="formData.scopeId">
            <el-option
              v-for="item in ProductsList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
          <!--
          <el-form-item label="可用用户类型" prop="scopeUser">
          <el-select v-model="formData.scopeUser">
            <el-option v-for="item in []" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        -->
          <!-- <el-form-item
          label="优惠券总数量"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '优惠券总数量不能为空'
          }"
          prop="quantity"
          v-if="!isEdit"
        >
          <el-input :min="0" type="number" v-model="formData.quantity"></el-input>
        </el-form-item> -->

          <!-- <el-form-item label="库存剩余数量" prop="stock">
          <el-input type="number" v-model="formData.stock"></el-input>
        </el-form-item>
        -->
          <!--
        <el-form-item label="是否随产品赠送" prop="giftWithProduct">
          <el-switch
            v-model="formData.giftWithProduct"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
        -->
          <el-form-item
            label="活动时间"
            class="date-wrapper"
            :rules="{
              required: true,
              trigger: 'blur',
              message: '活动时间不能为空'
            }"
            prop="timeRange"
            style="display: flex;
            flex-direction: column;"
          >
            <el-date-picker
              v-model="formData.timeRange"
              type="datetimerange"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="优惠券使用时间"
            class="date-wrapper"
            :rules="{
              required: true,
              trigger: 'blur',
              message: '优惠券使用时间不能为空'
            }"
            prop="timeRange"
          >
            <el-date-picker
              v-model="formData.durationTimeRange"
              type="datetimerange"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            ></el-date-picker>
          </el-form-item>
          <!--
        <el-form-item
          label="优惠券有效时长(天)"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '优惠券有效时长不能为空'
          }"
          prop="duration"
        >
          <el-input type="number" v-model="formData.duration"></el-input>
        </el-form-item>
        -->
          <el-form-item
            label="购买价格"
            :rules="{
              required: true,
              trigger: 'blur',
              message: '购买价格不能为空'
            }"
            prop="price"
          >
            <el-input :min="0" type="number" v-model="formData.price"></el-input>
          </el-form-item>
          <el-form-item
            label="优惠券折扣类型"
            :rules="{
              required: true,
              trigger: 'blur',
              message: '优惠券折扣类型不能为空'
            }"
            prop="type"
          >
            <el-select v-model="formData.type">
              <el-option
                v-for="item in options.CpsDiscountType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <template
            v-if="
              $util.isShowField(formData, 'type', 'type', 0) ||
                $util.isShowField(formData, 'type', 'type', 1)
            "
          >
            <el-form-item
              label="优惠券面值"
              :rules="{
                required: true,
                trigger: 'blur',
                message: '优惠券面值不能为空'
              }"
              prop="value"
            >
              <el-input :min="0" type="number" v-model="formData.value"></el-input>
            </el-form-item>
          </template>
          <template v-if="$util.isShowField(formData, 'type', 'type', 2)">
            <el-form-item
              label="优惠券面值（折）"
              :rules="{
                required: true,
                trigger: 'blur',
                message: '优惠券面值不能为空'
              }"
              prop="value"
            >
              <template slot="label">
                <span>
                  优惠券面值（折）
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="请输入0.01到1之间的数字"
                    placement="top-end"
                  >
                    <i class="el-icon-info c-color-primary"></i>
                  </el-tooltip>
                </span>
              </template>

              <el-input-number
                v-model="formData.value"
                :controls="false"
                :min="0.01"
                :precision="2"
                :max="1"
              ></el-input-number>
            </el-form-item>
          </template>

          <el-form-item
            label="使用条件"
            :rules="{
              required: true,
              trigger: 'blur',
              message: '优惠券面值不能为空'
            }"
            prop="prerequisites"
          >
            <template slot="label">
              <span>
                使用条件
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="满足多少钱才能使用"
                  placement="top-end"
                >
                  <i class="el-icon-info c-color-primary"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input :min="0" type="number" v-model="formData.prerequisites"></el-input>
          </el-form-item>
          <el-form-item label="用户限领取数量" prop="eachDelivery">
            <el-input v-model="formData.eachDelivery"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input v-model="formData.description"></el-input>
          </el-form-item>

          <!--  <el-form-item label="使用条件" prop="prerequisites">
          <el-select v-model="formData.prerequisites">
            <el-option v-for="item in []" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        -->
          <!--
        <el-form-item label="领取数量" prop="eachDelivery">
          <el-input type="number" v-model="formData.eachDelivery"></el-input>
        </el-form-item>
        -->
          <template v-for="(extField, idx) in extFields">
            <el-form-item
              :key="idx"
              :label="extField.nameDisp"
              v-if="extField.showList && extField.showList.indexOf('2') != -1"
            >
              <!-- pc表单展示的字段 -->
              <template>
                <template
                  v-if="
                    extField.type == 'text' ||
                      extField.type == 'textarea' ||
                      extField.type == 'number'
                  "
                >
                  <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
                </template>
                <template v-if="extField.type == 'radio'">
                  <el-radio-group v-model="formData.exts[extField.name]">
                    <el-radio
                      v-for="item in options[extField.valueOption]"
                      :key="item.value"
                      :label="item.value"
                    >
                      {{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </template>
                <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
                  <el-checkbox-group v-model="formData.exts[extField.name]">
                    <el-checkbox
                      v-for="item in options[extField.valueOption]"
                      :label="item.value"
                      :key="item.value"
                    >
                      {{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-if="extField.type == 'select'">
                  <el-select v-model="formData.exts[extField.name]" placeholder="请选择" clearable>
                    <el-option
                      v-for="item in options[extField.valueOption]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
                <template v-if="extField.type == 'cascade'">
                  <el-cascader
                    clearable
                    v-model="formData.exts[extField.name]"
                    :options="options[extField.valueOption]"
                    :props="{ checkStrictly: true, label: 'name' }"
                  ></el-cascader>
                </template>
                <template v-if="extField.type == 'time'">
                  <el-time-select
                    v-model="formData.exts[extField.name]"
                    placeholder="选择时间"
                  ></el-time-select>
                </template>
                <template v-if="extField.type == 'date' || extField.type == 'datetime'">
                  <el-date-picker
                    v-model="formData.exts[extField.name]"
                    :type="extField.type"
                    placeholder="选择日期"
                  ></el-date-picker>
                </template>
                <template v-if="extField.type == 'switch'">
                  <el-switch
                    v-model="formData.exts[extField.name]"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0"
                  ></el-switch>
                </template>
                <template v-if="extField.type == 'rate'">
                  <el-rate
                    v-model="formData.exts[extField.name]"
                    @change="$forceUpdate()"
                  ></el-rate>
                </template>
              </template>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div class="box-left-footer" v-if="false">
        <el-button type="primary" @click="doSave">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <!-- 动态 笔记 -->
    <div class="box-center">
      <el-tabs v-model="activeTab" class="c-h-1 c-flex c-flex-col">
        <el-tab-pane label="动态" name="log">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">{{ log.content }}</div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.createUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="笔记" name="notes">
          <div class="box-center-tool">
            <div></div>
            <el-button
              type="primary"
              size="mini"
              @click="
                vqeditor.content = ``;
                openNote = true;
              "
            >
              创建笔记
            </el-button>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(note, i) in noteData" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  笔记
                </span>
                <span>{{ note.createTime }}</span>
              </div>
              <div
                class="activity-card-content-node"
                v-html="note.content"
                @click="noteMdShow(note)"
                v-if="!note.openNote"
              ></div>
              <c-editor
                v-else
                class="c-m-15"
                :formData="note"
                :value="'content'"
                ref="editor"
              ></c-editor>
              <div class="activity-card-footer">
                <span>操作人：{{ note.createUserName }}</span>
              </div>
            </div>
          </div>
          <!-- markdown编辑器 -->
          <el-dialog title="笔记" :visible.sync="openNote">
            <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
            <div slot="footer">
              <el-button type="primary" @click="saveNote">确 认</el-button>
              <el-button
                @click="
                  openNote = false;
                  vqeditor.content = '';
                "
              >
                取 消
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="属性变更记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box-right" :class="collapse ? 'box-collapse' : ''">
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse">
        <el-collapse></el-collapse>
        <el-collapse></el-collapse>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'coupon',
  data() {
    let that = this;
    return {
      id: null,
      collapse: false,
      formData: { exts: {}, foundTime: '' },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      fpi: {},
      options: {
        codecfg_couponState: { codeId: 'couponState' },
        codecfg_couponType: { codeId: 'couponType' },
        codecfg_CpsDiscountType: { codeId: 'CpsDiscountType' }
      },
      rules: this.$util.rules,
      activeTab: 'log',
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      //地址级联-懒加载
      area: {
        options: [],
        props: {
          checkStrictly: true,
          lazy: true,
          async lazyLoad(node, resolve) {
            const { level } = node;
            var nodes = [];
            if (level == '0') {
              nodes = await that.$util.getProvince();
            } else if (level == '1') {
              node.children = [];
              let id = node.data.code;
              nodes = await that.$util.getCity(id);
            } else if (level == '2') {
              node.children = [];
              let id = node.data.code;
              nodes = await that.$util.getDistrict(id);
            }
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }
        }
      },
      contactList: [],
      //全部组织
      treeDataOptions: [],
      //人员列表
      userList: {
        relatedData: [],
        openEdit: false,
        formData: {}
      },
      //服务资源
      ServiceResource: {
        relatedData: [],
        openEdit: false,
        formData: {},
        searchObj: {},
        activeName: 'create'
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      isEdit: false,
      //产品列表
      ProductsList: []
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  beforeDestroy() {
    this.editor = null;
    delete this.editor;
  },
  mounted() {
    window.$this = this;
    this.id = this.osg.param('id');
    this.osg.getFields('coupon', () => {
      this.getData().then(() => {
        this.getProductsData();
      });
    });

    // this.osg.ajax(
    //   'biz/extField/query.do',
    //   {
    //     colName: 'coupon',
    //     _all: '1',
    //     'is:state|integer#and': 1,
    //     'nin:preset|array-integer#and': 1,
    //     sortField: 'order',
    //     sortOrder: 'asc'
    //   },
    //   res => {
    //     this.extFields = res.data;
    //     this.options = this.options || [];

    //     for (var item of res.data) {
    //       if (item.valueOption)
    //         this.options['codecfg_' + item.valueOption] = {
    //           codeId: item.valueOption
    //         };
    //       //级联
    //       if (item.type == 'cascade')
    //         this.options['cascadeCode_' + item.valueOption] = {
    //           codeId: item.valueOption
    //         };
    //     }
    //     this.osg.codeoption(() => {
    //       this.getData().then(() => {
    //         this.getProductsData();
    //       });
    //     });
    //   },
    //   { noload: true }
    // );
    this.getLog();
    this.getNote();
    // this.getContact();
  },
  methods: {
    getProductsData() {
      let params = {
        // page: this.fpi.page,
        // rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('basic/product/query.do', params, res => {
        res.data.map(item => {
          if (this.$util.isJson(item.image)) {
            item.image = JSON.parse(item.image);
          }
          item.label = item.name;
          item.value = item._id;
        });
        this.ProductsList = res.data;
      });
    },
    //上传头像图片文件转base64
    getFileToBase64(file, fileList) {
      var that = this;
      const isJPG = file.raw.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.osg.toast('上传头像图片只能是 JPG 格式！', 'error');
        return;
      }
      if (!isLt2M) {
        this.osg.toast('上传头像图片大小不能超过 2MB！', 'error');
        return;
      }
      this.$util.Base64.imgFile(file.raw).then(res => {
        if (res) {
          that.formData.avatar = res;
          that.$forceUpdate();
        } else {
          this.osg.toast('上传失败', 'error');
        }
      });
    },
    async getData() {
      this.osg.ajax(
        'basic/coupon/queryById.do',
        {
          id: this.id
        },
        res => {
          let row = this.$util.deepCopy(res.entity);
          row.type = String(row.type);
          // row.description = [row.description];
          if (row.startDate && row.endDate) row.timeRange = [row.startDate, row.endDate];
          if (row.startCouponDate && row.endCouponDate)
            row.durationTimeRange = [row.startCouponDate, row.endCouponDate];
          this.formData = row;
          //获取属性修改记录
          this.getHistory();
        }
      );
      // await this.getServiceResource();
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        if (this.formData.timeRange) {
          this.formData.startDate = this.formData.timeRange[0];
          this.formData.endDate = this.formData.timeRange[1];
          // let startDate = new Date(this.formData.timeRange[0]).getTime();
          // let nowDate = new Date().valueOf();
          // 当选择的开始时间大于现在的时间，这个优惠券未激活状态
          // if (startDate > nowDate) this.formData.state = 2;
          delete this.formData.timeRange;
        }
        this.osg.ajax('basic/coupon/upsert.do', this.formData, res => {
          this.getData().then(() => {
            this.osg.toast('保存成功！');
          });
        });
      }
    },
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'coupon',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue);
    },
    formatFieldValue(row, column, cellValue) {
      if (this.options[row.field]) {
        return this.osg.codelabel(row.field, cellValue);
      } else {
        return cellValue;
      }
    },
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'coupon'
        },
        res => {
          this.noteData = res || [];
        }
      );
    },
    //保存笔记
    saveNote() {
      var params = {
        //sid，smodul，content，id，isDelete(值Y) 保存传123,修改传1234,删除传12345
        sid: this.id,
        smodule: 'coupon',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, res => {
        this.osg.toast('保存成功！');
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    //根据网址 提示域名下拉框
    querySearch(queryString, cb) {
      let url = this.formData.website;
      let reg = /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})www\.(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
      if (reg.test(url)) {
        if (url.indexOf('www.') != -1) {
          url = url.substr(url.indexOf('.') + 1);
        } else if (url.indexOf('http://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
        } else if (url.indexOf('https://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
          if (url.indexOf('https://www.') != -1) {
            url = url.substr(url.indexOf('.') + 1);
          }
        }
        // 调用 callback 返回建议列表的数据
        cb([{ label: url, value: url }]);
      } else {
        cb([{}]);
      }
    },
    //新增服务资源
    addServiceResource() {
      this.ServiceResource.formData = {};
      this.ServiceResource.openEdit = true;
    },
    //删除服务资源
    removeServiceResource(removeResourcesId) {
      return new Promise(resolve => {
        this.osg.ajax(`biz/serviceResource/remove/${removeResourcesId}.do`, null, res => {
          resolve();
        });
      });
    },
    //保存服务资源
    doSaveServiceResource() {
      if (this.osg.validate()) {
        if (this.ServiceResource.relatedData.length) {
          let removeResourcesId = this.ServiceResource.relatedData[0]._id;
          this.removeServiceResource(removeResourcesId).then(() => {
            this.doSaveResource();
          });
        } else {
          this.doSaveResource();
        }
      }
    },
    doSaveResource() {
      let params = this.$util.deepCopy(this.ServiceResource.formData);
      this.$util.saveExtField(this.extFields, params);
      //保存经纬度
      params['gpsPoint.longitude'] = params.gpsPoint && params.gpsPoint.longitude;
      params['gpsPoint.latitude'] = params.gpsPoint && params.gpsPoint.latitude;
      delete params.gpsPoint;
      params.resourceType = 'coupon';
      params.relatedId = this.formData.orgId;
      params.relatedName = this.formData.name;
      this.osg.ajax('biz/serviceResource/upsert.do', params, res => {
        this.getData();
        this.initServiceResource();
        this.osg.toast('保存成功！');
      });
    },
    initServiceResource() {
      this.ServiceResource.openEdit = false;
      this.ServiceResource.formData = { exts: {}, gpsPoint: {} };
      this.$util.renderExtField(this.extFields, this.ServiceResource.formData);
    },
    //获取用户
    getUser(query) {
      let params = {
        page: 1,
        rows: 20,
        tenantId: this.tenantId,
        'regex:name|string#or': query
      };
      this.osg.ajax('user/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.user = res.data;
      });
    },
    //获取地理编码
    async getGeocode() {
      if (this.ServiceResource.formData.lastKnownLocation) {
        this.osg.geocode(this.ServiceResource.formData.lastKnownLocation, res => {
          this.ServiceResource.formData.gpsPoint = {
            longitude: res.location.split(',')[0],
            latitude: res.location.split(',')[1]
          };
          this.ServiceResource.formData.lastKnownLocationDate = new Date()
            .toLocaleString('chinese', {
              hour12: false
            })
            .replace(/\//g, '-');
          this.$forceUpdate();
        });
      }
    },
    editServiceResource(item) {
      this.ServiceResource.formData = this.$util.deepCopy(item);
      this.ServiceResource.openEdit = true;
    },
    //获取组织
    getOrg() {
      return new Promise(resolve => {
        this.osg.ajax('org/query.do', {}, res => {
          if (res.data) {
            let data = [res.data];
            this.treeData = data;
            this.treeDataOptions = this.removeEmpty(
              res.data && res.data.orgList ? res.data.orgList : []
            );
            // this.formData.description = !res.data._id ? "" : res.data._id;
            resolve();
          }
        });
      });
    },
    //删除空数组并且扁平化
    removeEmpty(arr) {
      if (Array.isArray(arr)) {
        arr.forEach(item => {
          if (item.orgList ? item.orgList.length === 0 : false) {
            delete item.orgList;
          } else {
            this.removeEmpty(item.orgList);
          }
        });
        return arr;
      }
    }
  }
};
</script>
<style scoped>
#app .box-left-content {
  flex: 1;
  padding: 10px;
  overflow-y: scroll;
  overflow: hidden;
}
/*个人信息*/
.box-left-header-contact {
  border-bottom: 1px solid #dfe3eb;
}
.profile-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 50px;
}
.profile-info > * {
  margin: 10px auto;
}
.profile-info > span {
  margin: 0;
  font-weight: 400;
  font-size: 24px;
}
.profile-info ul {
  display: flex;
}
.profile-info ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 5px;
}
.profile-info ul li span {
  margin-top: 8px;
  font-size: 12px;
}
/* 快捷按钮 */
.shortcuts button {
  background-color: #eaf0f6;
  border-color: #cbd6e2;
  color: #506e91;
}
.shortcuts button i {
  font-weight: bold;
}
.date-wrapper >>> .el-form-item__content {
  margin-left: 0px !important;
  margin-top: 10px;
}
</style>
